<template>
    <div>
        <a-page-header style="margin-top: 20px" class="fun-panel" title="单位注册申请" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="primary" @click="submit()">提交</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }">
                            <FGCollapsiblePanel title="基本信息">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="用户名" required>
                                            <a-input-search
                                                ref="yhm"
                                                v-model="editData.yhm"
                                                @search="checkUsername"
                                                @change="
                                                    () => {
                                                        usernameFlag.type = false;
                                                    }
                                                "
                                            >
                                                <a-button slot="enterButton">
                                                    用户名检测
                                                </a-button>
                                            </a-input-search>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="密码" required>
                                            <a-input ref="mm" v-model="editData.mm" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="确认密码" required>
                                            <a-input ref="qrmm" v-model="editData.qrmm" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位类型" required>
                                            <FGDictSelectCN ref="dwlx" dictNo="DW100201" v-model="editData.dwlx" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位名称" required>
                                            <a-input ref="dwmc" v-model="editData.dwmc" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="区域编号" required>
                                            <a-input-search read-only @search="isShow1 = true" ref="qybh" v-model="editData.qybh" />
                                            <FGDataSelectForRegister
                                                :isShow.sync="isShow1"
                                                selectNo="JC100101T"
                                                @saveselect="saveEvent(arguments)"
                                            ></FGDataSelectForRegister>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="区域名称">
                                            <a-input ref="qymc" v-model="editData.qymc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="注册地址" required>
                                            <a-input ref="zcdz" v-model="editData.zcdz" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="办公地址" required>
                                            <a-input ref="bgdz" v-model="editData.bgdz" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="邮政编码" required>
                                            <a-input ref="yzbm" v-model="editData.yzbm" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="行业分类" required>
                                            <a-input-search read-only @search="isShow2 = true" ref="hyfl" v-model="editData.hyfl" />
                                            <FGDataSelectForRegister
                                                :isShow.sync="isShow2"
                                                selectNo="JC1002"
                                                @saveselect="saveEvent1(arguments)"
                                            ></FGDataSelectForRegister>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="注册资金(万元)" required>
                                            <a-input-number ref="zczj" v-model="editData.zczj" style="width:100%" :min="0" :precision="6" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="法人代表" required>
                                            <a-input ref="frdb" v-model="editData.frdb" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="法人固定电话" required>
                                            <a-input ref="frgddh" v-model="editData.frgddh" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="法人移动电话" required>
                                            <a-input ref="fryddh" v-model="editData.fryddh" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="联系人" required>
                                            <a-input ref="lxr" v-model="editData.lxr" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="联系人部门" required>
                                            <a-input ref="lxrbm" v-model="editData.lxrbm" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="联系人职务">
                                            <a-input ref="lxrzw" v-model="editData.lxrzw" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="固定电话" required>
                                            <a-input ref="gddh" v-model="editData.gddh" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="移动电话" required>
                                            <a-input ref="yddh" v-model="editData.yddh" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="传真">
                                            <a-input ref="cz" v-model="editData.cz" />
                                        </a-form-item>
                                    </a-col>
                                    <!-- <a-col :span="12">
                                        <a-form-item label="电子邮箱">
                                            <a-input ref="dzyx" v-model="editData.dzyx" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="信息/通讯员">
                                            <a-input ref="xxyxm" v-model="editData.xxyxm" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="信息/通讯员电话">
                                            <a-input ref="xxydh" v-model="editData.xxydh" />
                                        </a-form-item>
                                    </a-col> -->
                                    <a-col :span="12">
                                        <a-form-item label="网址">
                                            <a-input ref="wz" v-model="editData.wz" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位性质" required>
                                            <FGDictSelectCN ref="dwxz" dictNo="DW100103" v-model="editData.dwxz" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="是否建立党组织" required>
                                            <FGDictSelectCN ref="sfjldzz" dictNo="1101" v-model="editData.sfjldzz" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="职工总人数" required>
                                            <a-input-number ref="zgzrs" v-model="editData.zgzrs" style="width:100%" required :min="0" :precision="0" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="专业技术人员数" required>
                                            <a-input-number ref="zyjsrs" v-model="editData.zyjsrs" style="width:100%" required :min="0" :precision="0" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="专职从事工程咨询人数" required>
                                            <a-input-number ref="zzcszxrs" v-model="editData.zzcszxrs" style="width:100%" required :min="0" :precision="0" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="已登记咨询师人数" required>
                                            <a-input-number ref="zczxsrs" v-model="editData.zczxsrs" style="width:100%" required :min="0" :precision="0" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="高级职称人数" required>
                                            <a-input-number ref="gjzcrs" v-model="editData.gjzcrs" style="width:100%" required :min="0" :precision="0" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="中级职称人数" required>
                                            <a-input-number ref="zjzcrs" v-model="editData.zjzcrs" style="width:100%" required :min="0" :precision="0" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="初级职称人数" required>
                                            <a-input-number ref="cjzcrs" v-model="editData.cjzcrs" style="width:100%" required :min="0" :precision="0" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="博士人数" required>
                                            <a-input-number ref="bsrs" v-model="editData.bsrs" style="width:100%" required :min="0" :precision="0" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="硕士人数" required>
                                            <a-input-number ref="ssrs" v-model="editData.ssrs" style="width:100%" required :min="0" :precision="0" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="本科人数" required>
                                            <a-input-number ref="bkrs" v-model="editData.bkrs" style="width:100%" required :min="0" :precision="0" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="办公面积(平方)" required>
                                            <a-input-number ref="bgmj" v-model="editData.bgmj" style="width:100%" :min="0" :precision="2" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="其中自有面积(平方)" required>
                                            <a-input-number ref="zymj" v-model="editData.zymj" style="width:100%" :min="0" :precision="2" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="计算机台数">
                                            <a-input-number ref="jsjts" v-model="editData.jsjts" style="width:100%" :min="0" :precision="0" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="质量体系认证">
                                            <a-input ref="zltxrz" v-model="editData.zltxrz" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="认证时间">
                                            <a-date-picker ref="rzrq" v-model="editData.rzrq" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="认证机构">
                                            <a-input ref="rzjg" v-model="editData.rzjg" />
                                        </a-form-item>
                                    </a-col>
                                    <!-- <a-col :span="12">
                                        <a-form-item label="理事代表">
                                            <a-input ref="lsdb" v-model="editData.lsdb" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="理事代表联系方式">
                                            <a-input ref="lsdblxfs" v-model="editData.lsdblxfs" />
                                        </a-form-item>
                                    </a-col> -->
                                    <a-col :span="12">
                                        <a-form-item label="纳税人识别号" required>
                                            <a-input ref="nsrsbh" v-model="editData.nsrsbh" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="开票地址" required>
                                            <a-input ref="kpdz" v-model="editData.kpdz" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="开票电话" required>
                                            <a-input ref="kpdh" v-model="editData.kpdh" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="开户行" required>
                                            <a-input ref="khh" v-model="editData.khh" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="开户行账号" required>
                                            <a-input ref="khzh" v-model="editData.khzh" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="单位简介" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }" required>
                                            <a-textarea v-model="editData.dwjj" :rows="3" />
                                        </a-form-item>
                                    </a-col>

                                    <a-col :span="24">
                                        <a-form-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                                            <a-textarea v-model="editData.bz" :rows="3" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                        </a-form>
                        <!-- 其他资质证书明细表格 -->
                        <FGCollapsiblePanel title="其他资质证书">
                            <vxe-toolbar size="mini">
                                <template v-slot:tools>
                                    <a-button type="primary" :loading="saving || loading" @click="insertQtzzzsItem">新增</a-button>
                                </template>
                            </vxe-toolbar>
                            <vxe-table
                                ref="QTZZZSitemTable"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                highlight-current-row
                                show-overflow="tooltip"
                                :data="editItemDataQTZZZS"
                                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                            >
                                <vxe-table-column type="seq" title="序号" width="70" align="center"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.xh" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="zslb"
                                    title="证书类别"
                                    width="130"
                                    header-class-name="required"
                                    sortable
                                    ><template v-slot:edit="scope"> <FGDictSelectCN ref="zslb" dictNo="ZX100104" v-model="scope.row.zslb" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="zsmc"
                                    title="证书名称"
                                    width="200"
                                    header-class-name="required"
                                    sortable
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.zsmc" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="zsbh"
                                    title="证书编号"
                                    header-class-name="required"
                                    width="150"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.zsbh" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="zsdj"
                                    title="证书等级"
                                    width="120"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.zsdj" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="zsrq"
                                    title="证书日期"
                                    width="120"
                                    header-class-name="required"
                                    align="center"
                                >
                                    <template v-slot:edit="scope">
                                        <a-date-picker
                                            ref="zsrq"
                                            v-model="scope.row.zsrq"
                                            width="100%"
                                            valueFormat="YYYY-MM-DD"
                                            style="width:100%"
                                            @change="zsdqrqChangeEvent(scope.row)"
                                        />
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column
                                    field="zzyxq"
                                    title="资质有效期(年)"
                                    width="105"
                                    align="right"
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                >
                                    <template v-slot:edit="scope">
                                        <a-input-number size="small" v-model="scope.row.zzyxq" @change="zsdqrqChangeEvent(scope.row)" :min="0" :precision="0" />
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="zsdqrq" title="证书到期日期" width="100" align="center">
                                    <template v-slot:edit="scope">
                                        <a-date-picker ref="zsdqrq" v-model="scope.row.zsdqrq" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" />
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="bz"
                                    title="备注"
                                    min-width="200"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.bz" /> </template
                                ></vxe-table-column>
                                <vxe-table-column title="附件上传" width="180" align="center">
                                    <template v-slot="scope">
                                        <span class="btn_edit" @click="attachInsert(scope.row)">上传其他资质证书材料</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column title="操作" align="center" width="100">
                                    <template v-slot="scope">
                                        <span class="btn_edit" @click="removeQtzzzsItem(scope.row)">删除</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 分支机构明细表格 -->
                        <FGCollapsiblePanel title="分支机构">
                            <vxe-toolbar size="mini">
                                <template v-slot:tools>
                                    <a-button type="primary" :loading="saving || loading" @click="insertFzjgItem">新增</a-button>
                                </template>
                            </vxe-toolbar>
                            <vxe-table
                                ref="FZJGitemTable"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                highlight-current-row
                                show-overflow="tooltip"
                                :data="editItemDataFZJG"
                                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                            >
                                <vxe-table-column type="seq" title="序号" width="70" align="center"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.xh" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="jgmc"
                                    title="机构名称"
                                    width="200"
                                    header-class-name="required"
                                    sortable
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.jgmc" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="xxdz"
                                    title="详细地址"
                                    width="250"
                                    header-class-name="required"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.xxdz" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="yzbm"
                                    title="邮政编码"
                                    width="100"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.yzbm" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="dzyx"
                                    title="电子邮箱"
                                    width="150"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.dzyx" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="fzr"
                                    title="负责人"
                                    width="100"
                                    header-class-name="required"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.fzr" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="fzrdh"
                                    title="负责人电话"
                                    width="100"
                                    header-class-name="required"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.fzrdh" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="bz"
                                    title="备注"
                                    min-width="200"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.bz" /> </template
                                ></vxe-table-column>
                                <vxe-table-column title="操作" align="center" width="100">
                                    <template v-slot="scope">
                                        <span class="btn_edit" @click="removeFzjgItem(scope.row)">删除</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 单位通讯员明细表格 -->
                        <FGCollapsiblePanel title="单位通讯员">
                            <vxe-toolbar size="mini">
                                <template v-slot:tools>
                                    <a-button type="primary" :loading="saving || loading" @click="insertLxrItem">新增</a-button>
                                </template>
                            </vxe-toolbar>
                            <vxe-table
                                ref="LXRitemTable"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                highlight-current-row
                                show-overflow="tooltip"
                                :data="editItemDataLXR"
                                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                            >
                                <vxe-table-column type="seq" title="序号" width="70" align="center"
                                    ><template v-slot:edit="scope"><a-input size="small" v-model="scope.row.xh" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="lxr"
                                    title="通讯员姓名"
                                    width="110"
                                    header-class-name="required"
                                    sortable
                                    ><template v-slot:edit="scope"><a-input size="small" v-model="scope.row.lxr" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="bmmc"
                                    title="部门"
                                    width="150"
                                    header-class-name="required"
                                    ><template v-slot:edit="scope"><a-input size="small" v-model="scope.row.bmmc" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="zw"
                                    title="职务"
                                    width="120"
                                    header-class-name="required"
                                    ><template v-slot:edit="scope"><a-input size="small" v-model="scope.row.zw" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="qq"
                                    title="QQ"
                                    width="100"
                                    ><template v-slot:edit="scope"><a-input size="small" v-model="scope.row.qq" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="gddh"
                                    title="固定电话"
                                    width="100"
                                    ><template v-slot:edit="scope"><a-input size="small" v-model="scope.row.gddh" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="yddh"
                                    title="移动电话"
                                    width="100"
                                    ><template v-slot:edit="scope"><a-input size="small" v-model="scope.row.yddh" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="dzyx"
                                    title="电子邮箱"
                                    width="150"
                                    ><template v-slot:edit="scope"><a-input size="small" v-model="scope.row.dzyx" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="txdz"
                                    title="通讯地址"
                                    width="250"
                                    ><template v-slot:edit="scope"><a-input size="small" v-model="scope.row.txdz" /> </template
                                ></vxe-table-column>
                                <!-- <vxe-table-column field="zsbh" title="证书编号" width="130"
                                    ><template v-slot:edit="scope"><a-input size="small" v-model="scope.row.zsbh" /> </template
                                ></vxe-table-column> -->
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="bz"
                                    title="备注"
                                    min-width="200"
                                    ><template v-slot:edit="scope"><a-input size="small" v-model="scope.row.bz" /> </template
                                ></vxe-table-column>
                                <vxe-table-column title="操作" align="center" width="100">
                                    <template v-slot="scope">
                                        <span class="btn_edit" @click="removeLxrItem(scope.row)">删除</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <FGCollapsiblePanel title="相关附件">
                            <a-form ref="form" class="fun-edit-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="营业执照扫描件" required>
                                            <UploadButtonRegister :state="state" field="yyzz" :attachCfg.sync="attachCfg_Edit" />
                                            <a-tooltip style="margin-left: 10px;color: red">
                                                <template slot="title">
                                                    5M以内,文件需要命名为【营业执照】
                                                </template>
                                                <a-icon type="exclamation-circle" />
                                            </a-tooltip>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="注册申请表扫描件" required>
                                            <UploadButtonRegister :state="state" field="zcsqb" :attachCfg.sync="attachCfg_Edit" />
                                            <a-tooltip style="margin-left: 10px;color: red">
                                                <template slot="title">
                                                    申请表请申请单位自行编写，无固定格式；须加盖单位有效公章”，“5M以内,文件需要命名为【注册申请表】
                                                </template>
                                                <a-icon type="exclamation-circle" />
                                            </a-tooltip>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </a-form>
                        </FGCollapsiblePanel>
                    </a-spin>
                    <!-- 操作日志 -->
                    <!--                    <OperLog ref="operlog" :operLogProps="operLogProps"></OperLog>-->
                    <AttachModalUploadRegister :attachCfg.sync="attachProps" />
                </a-layout-content>
            </a-layout>
        </a-page-header>
    </div>
</template>

<script>
import { createNamespacedHelpers, mapActions } from "vuex";
const user = createNamespacedHelpers("user");
export default {
    name: "DwxxwhEdit",
    data() {
        return {
            usernameFlag: {
                type: false
            },
            // 避免重复点击提交
            saving: false,
            isShow1: false,
            isShow2: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            //资质证书及服务范围
            editItemDataZZZS: [],
            editItemDataZZZSLoading: false,
            //其它资质证书
            editItemDataQTZZZS: [],
            editItemDataQTZZZSLoading: false,
            //分支机构
            editItemDataFZJG: [],
            editItemDataFZJGLoading: false,
            //项目成果获奖情况
            editItemDataXMCG: [],
            editItemDataXMCGLoading: false,
            //单位通讯员
            editItemDataLXR: [],
            editItemDataLXRLoading: false,
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            },
            state: 1,
            attachProps: {
                visible: false,
                fkvalue: null,
                fktable: "DW_ZCSQB_QTZZZS",
                fkfield: "ID",
                attachSource: "DW2001"
            }
        };
    },
    computed: {
        ...user.mapGetters(["getUserInfo"]),

        subTitle() {
            return "";
        },
        loading() {
            return this.editDataLoading;
        },
        attachCfg_Edit() {
            return {
                fktable: "DW_ZCSQB",
                fkvalue: this.editData.id,
                attachsource: "DW2001"
            };
        }
    },
    activated() {
        this.usernameFlag.type = false;
    },
    mounted() {
        // 新增，设置默认值
        this.editData = {
            id: this.$FG_util.uuid(),
            isnew: true,
            djlxid: "ZCSQB",
            /*bmid: this.getUserInfo.org_id,
            yhid: this.getUserInfo.id,
            ryid: this.getUserInfo.personnel_id,*/
            djzt: "制定",
            zcsqbbh: this.$FG_helper.handleNewBillCodeForRegister("ZCSQBBH").then((val) => {
                this.editData.zcsqbbh = val;
            }),
            /*lrbmmc: this.getUserInfo.org_name,
            lrrxm: this.getUserInfo.personnel_name,*/
            lrrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD"),
            zczj: 0,
            zgzrs: 0,
            zyjsrs: 0,
            zzcszxrs: 0,
            zczxsrs: 0,
            gjzcrs: 0,
            zjzcrs: 0,
            cjzcrs: 0,
            bsrs: 0,
            ssrs: 0,
            bkrs: 0,
            bgmj: 0,
            zymj: 0,
            jsjts: 0
        };
        this.tableData = [];
    },
    methods: {
        ...user.mapActions(["setToken", "setUserInfo"]),
        ...mapActions(["setStaticVarData", "setMessageData", "setDictData", "setSelectData", "setObjVarData"]),
        checkUsername() {
            this.$FG_http
                .post(
                    "./api/jsaec/register/check",
                    {
                        username: this.editData.yhm
                    },
                    { showSuccess: false }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        this.usernameFlag.type = data.data;
                        if (data.data) {
                            this.$FG_message.warn("当前用户名可用！").then(() => this.$refs.yhm.focus());
                        } else {
                            this.$FG_message.error("当前用户名已被注册！").then(() => this.$refs.yhm.focus());
                        }
                    } else {
                        this.$refs.yhm.focus();
                    }
                });
        },
        zsdqrqChangeEvent(row) {
            this.selCYMXRow = row;
            if (row.zsrq === null) {
                this.selCYMXRow.zsdqrq = null;
            } else {
                this.selCYMXRow.zsdqrq = parseInt(row.zsrq.substring(0, 4)) + row.zzyxq + row.zsrq.substring(4, row.zsrq.length);
            }
        },
        saveEvent(val) {
            if (val && val.length > 0) {
                this.editData.qybh = val[0][0].QYBH;
                this.editData.qymc = val[0][0].QYMC;
                this.editData.qyid = val[0][0].ID;
            }
        },
        saveEvent1(val) {
            if (val && val.length > 0) {
                this.editData.hyfl = val[0][0].ZYMC;
            }
        },
        //提交form
        onSave(showSuccess) {
            return new Promise((resolve, reject) => {
                if (!this.usernameFlag.type) {
                    this.$FG_message.error("请先完成用户名检测!").then(() => this.$refs.yhm.focus());
                    return;
                }
                // 表单校验
                if (!this.editData.yhm) {
                    this.$FG_message.error("P0001", "用户名").then(() => this.$refs.yhm.focus());
                    return;
                }
                if (!this.editData.mm) {
                    this.$FG_message.error("P0001", "密码").then(() => this.$refs.mm.focus());
                    return;
                }
                if (!this.editData.qrmm) {
                    this.$FG_message.error("P0001", "确认密码").then(() => this.$refs.qrmm.focus());
                    return;
                }
                if (this.editData.qrmm !== this.editData.mm) {
                    this.editData.qrmm = null;
                    this.$FG_message.error("两次密码不一致，请重新输入！").then(() => this.$refs.qrmm.focus());
                    return;
                }
                if (!this.editData.dwmc) {
                    this.$FG_message.error("P0001", "单位名称").then(() => this.$refs.dwmc.focus());
                    return;
                }
                if (!this.editData.dwlx) {
                    this.$FG_message.error("P0001", "单位类型").then(() => this.$refs.dwlx.focus());
                    return;
                }
                if (!this.editData.dwxz) {
                    this.$FG_message.error("P0001", "单位性质").then(() => this.$refs.dwxz.focus());
                    return;
                }
                if (!this.editData.sfjldzz) {
                    this.$FG_message.error("P0001", "是否建立党组织").then(() => this.$refs.sfjldzz.focus());
                    return;
                }
                if (!this.editData.qybh) {
                    this.$FG_message.error("P0001", "区域编号").then(() => this.$refs.qybh.focus());
                    return;
                }
                if (!this.editData.zcdz) {
                    this.$FG_message.error("P0001", "注册地址").then(() => this.$refs.zcdz.focus());
                    return;
                }
                if (!this.editData.bgdz) {
                    this.$FG_message.error("P0001", "办公地址").then(() => this.$refs.bgdz.focus());
                    return;
                }
                if (!this.editData.yzbm) {
                    this.$FG_message.error("P0001", "邮政编码").then(() => this.$refs.yzbm.focus());
                    return;
                }
                if (!this.editData.hyfl) {
                    this.$FG_message.error("P0001", "行业分类").then(() => this.$refs.hyfl.focus());
                    return;
                }
                if (!this.editData.zczj) {
                    this.$FG_message.error("P0001", "注册资金").then(() => this.$refs.zczj.focus());
                    return;
                }
                if (!this.editData.frdb) {
                    this.$FG_message.error("P0001", "法人代表").then(() => this.$refs.frdb.focus());
                    return;
                }
                if (!this.editData.frgddh) {
                    this.$FG_message.error("P0001", "法人固定电话").then(() => this.$refs.frgddh.focus());
                    return;
                }
                if (!this.editData.fryddh) {
                    this.$FG_message.error("P0001", "法人移动电话").then(() => this.$refs.fryddh.focus());
                    return;
                }
                if (!this.editData.lxr) {
                    this.$FG_message.error("P0001", "联系人").then(() => this.$refs.lxr.focus());
                    return;
                }
                if (!this.editData.lxrbm) {
                    this.$FG_message.error("P0001", "联系人部门").then(() => this.$refs.lxrbm.focus());
                    return;
                }
                if (!this.editData.gddh) {
                    this.$FG_message.error("P0001", "固定电话").then(() => this.$refs.gddh.focus());
                    return;
                }
                if (!this.editData.yddh) {
                    this.$FG_message.error("P0001", "移动电话").then(() => this.$refs.yddh.focus());
                    return;
                }
                if (!this.editData.zgzrs && this.editData.zgzrs !== 0) {
                    this.$FG_message.error("P0001", "职工总人数").then(() => this.$refs.zgzrs.focus());
                    return;
                }
                if (!this.editData.zyjsrs && this.editData.zgzrs !== 0) {
                    this.$FG_message.error("P0001", "专业技术人员数").then(() => this.$refs.zyjsrs.focus());
                    return;
                }
                if (!this.editData.zzcszxrs && this.editData.zzcszxrs !== 0) {
                    this.$FG_message.error("P0001", "专职从事工程咨询人数").then(() => this.$refs.zzcszxrs.focus());
                    return;
                }
                if (!this.editData.zczxsrs && this.editData.zczxsrs !== 0) {
                    this.$FG_message.error("P0001", "已登记咨询师人数").then(() => this.$refs.zczxsrs.focus());
                    return;
                }
                if (!this.editData.gjzcrs && this.editData.gjzcrs !== 0) {
                    this.$FG_message.error("P0001", "高级职称人数").then(() => this.$refs.gjzcrs.focus());
                    return;
                }
                if (!this.editData.zjzcrs && this.editData.zjzcrs !== 0) {
                    this.$FG_message.error("P0001", "中级职称人数").then(() => this.$refs.zjzcrs.focus());
                    return;
                }
                if (!this.editData.cjzcrs && this.editData.cjzcrs !== 0) {
                    this.$FG_message.error("P0001", "初级职称人数").then(() => this.$refs.cjzcrs.focus());
                    return;
                }
                if (!this.editData.bsrs && this.editData.bsrs !== 0) {
                    this.$FG_message.error("P0001", "博士人数").then(() => this.$refs.bsrs.focus());
                    return;
                }
                if (!this.editData.ssrs && this.editData.ssrs !== 0) {
                    this.$FG_message.error("P0001", "硕士人数").then(() => this.$refs.ssrs.focus());
                    return;
                }
                if (!this.editData.bkrs && this.editData.bkrs !== 0) {
                    this.$FG_message.error("P0001", "本科人数").then(() => this.$refs.bkrs.focus());
                    return;
                }
                if (!this.editData.bgmj && this.editData.bgmj !== 0) {
                    this.$FG_message.error("P0001", "办公面积(平方)").then(() => this.$refs.bgmj.focus());
                    return;
                }
                if (!this.editData.zymj && this.editData.zymj !== 0) {
                    this.$FG_message.error("P0001", "其中自有面积(平方)").then(() => this.$refs.zymj.focus());
                    return;
                }
                if (!this.editData.nsrsbh) {
                    this.$FG_message.error("P0001", "纳税人识别号").then(() => this.$refs.nsrsbh.focus());
                    return;
                }
                if (!this.editData.dwjj) {
                    this.$FG_message.error("P0001", "单位简介").then(() => this.$refs.dwjj.focus());
                    return;
                }
                if (!this.editData.kpdz) {
                    this.$FG_message.error("P0001", "开票地址").then(() => this.$refs.kpdz.focus());
                    return;
                }
                if (!this.editData.kpdh) {
                    this.$FG_message.error("P0001", "开票电话").then(() => this.$refs.kpdh.focus());
                    return;
                }
                if (!this.editData.khh) {
                    this.$FG_message.error("P0001", "开户行").then(() => this.$refs.khh.focus());
                    return;
                }
                if (!this.editData.khzh) {
                    this.$FG_message.error("P0001", "开户行账号").then(() => this.$refs.khzh.focus());
                    return;
                }
                // 获取变化的数据
                let QTZZZSitemData = this.$refs.QTZZZSitemTable.getInsertRecords().concat(this.$refs.QTZZZSitemTable.getUpdateRecords());
                let QTZZZSitemRemovedData = this.$refs.QTZZZSitemTable.getRemoveRecords().map((item) => item.id);
                for (let i = 0; i < QTZZZSitemData.length; i++) {
                    if (!QTZZZSitemData[i].zslb) {
                        this.$FG_message.error("P0001", "证书类别").then(() => {
                            this.$refs.QTZZZSitemTable.setActiveRow(QTZZZSitemData[i]);
                        });
                        return;
                    }
                    if (!QTZZZSitemData[i].zsbh) {
                        this.$FG_message.error("P0001", "证书编号").then(() => {
                            this.$refs.QTZZZSitemTable.setActiveRow(QTZZZSitemData[i]);
                        });
                        return;
                    }
                    if (!QTZZZSitemData[i].zsmc) {
                        this.$FG_message.error("P0001", "证书名称").then(() => {
                            this.$refs.QTZZZSitemTable.setActiveRow(QTZZZSitemData[i]);
                        });
                        return;
                    }
                    if (!QTZZZSitemData[i].zsrq) {
                        this.$FG_message.error("P0001", "证书日期").then(() => {
                            this.$refs.QTZZZSitemTable.setActiveRow(QTZZZSitemData[i]);
                        });
                        return;
                    }
                }
                let FZJGitemData = this.$refs.FZJGitemTable.getInsertRecords().concat(this.$refs.FZJGitemTable.getUpdateRecords());
                let FZJGitemRemovedData = this.$refs.FZJGitemTable.getRemoveRecords().map((item) => item.id);
                for (let i = 0; i < FZJGitemData.length; i++) {
                    if (!FZJGitemData[i].jgmc) {
                        this.$FG_message.error("P0001", "机构名称").then(() => {
                            this.$refs.FZJGitemTable.setActiveRow(FZJGitemData[i]);
                        });
                        return;
                    }
                    if (!FZJGitemData[i].xxdz) {
                        this.$FG_message.error("P0001", "详细地址").then(() => {
                            this.$refs.FZJGitemTable.setActiveRow(FZJGitemData[i]);
                        });
                        return;
                    }
                    if (!FZJGitemData[i].fzr) {
                        this.$FG_message.error("P0001", "负责人").then(() => {
                            this.$refs.FZJGitemTable.setActiveRow(FZJGitemData[i]);
                        });
                        return;
                    }
                    if (!FZJGitemData[i].fzrdh) {
                        this.$FG_message.error("P0001", "负责人电话").then(() => {
                            this.$refs.FZJGitemTable.setActiveRow(FZJGitemData[i]);
                        });
                        return;
                    }
                }
                let LXRitemData = this.$refs.LXRitemTable.getInsertRecords().concat(this.$refs.LXRitemTable.getUpdateRecords());
                let LXRitemRemovedData = this.$refs.LXRitemTable.getRemoveRecords().map((item) => item.id);
                for (let i = 0; i < LXRitemData.length; i++) {
                    if (!LXRitemData[i].lxr) {
                        this.$FG_message.error("P0001", "通讯人姓名").then(() => {
                            this.$refs.LXRitemTable.setActiveRow(LXRitemData[i]);
                        });
                        return;
                    }
                    if (!LXRitemData[i].bmmc) {
                        this.$FG_message.error("P0001", "部门").then(() => {
                            this.$refs.LXRitemTable.setActiveRow(LXRitemData[i]);
                        });
                        return;
                    }
                    if (!LXRitemData[i].zw) {
                        this.$FG_message.error("P0001", "职务").then(() => {
                            this.$refs.LXRitemTable.setActiveRow(LXRitemData[i]);
                        });
                        return;
                    }
                }
                let fileClass = document.getElementsByClassName("uploadBtn");
                if (fileClass.length > 0) {
                    this.$FG_message.error("请上传文件").then(() => {
                        fileClass[0].focus();
                    });
                    return;
                }
                if (this.editData.nsrsbh) {
                    this.$FG_http
                        .post(
                            "./api/jsaec/register/checknsrsbh",
                            {
                                no: this.editData.nsrsbh
                            },
                            {
                                showSuccess: false
                            }
                        )
                        .then(({ success, data, errMsg }) => {
                            if (success) {
                                if (data.data === 1) {
                                    this.$FG_message.error("当前单位已提交注册申请，等待审核中！").then(() => this.$refs.nsrsbh.focus());
                                    return;
                                } else if (data.data === 2) {
                                    this.$FG_message.error("当前单位已注册，请勿重复注册！").then(() => this.$refs.nsrsbh.focus());
                                    return;
                                } else {
                                    // 保存操作
                                    this.saving = true;
                                    this.$FG_http
                                        .post(
                                            "./api/jsaec/register/save",
                                            {
                                                data: this.editData,
                                                QTZZZSitemData,
                                                QTZZZSitemRemovedData,
                                                FZJGitemData,
                                                FZJGitemRemovedData,
                                                LXRitemData,
                                                LXRitemRemovedData
                                            },
                                            {
                                                showSuccess: showSuccess
                                            }
                                        )
                                        .then(({ success, data, errMsg }) => {
                                            this.saving = false;
                                            if (success) {
                                                this.editData.isnew = false;
                                                QTZZZSitemData.forEach((item, index) => {
                                                    item.isnew = false;
                                                });
                                                FZJGitemData.forEach((item, index) => {
                                                    item.isnew = false;
                                                });
                                                LXRitemData.forEach((item, index) => {
                                                    item.isnew = false;
                                                });
                                                resolve(true);
                                            } else {
                                                this.$refs.yhm.focus();
                                            }
                                        });
                                }
                            } else {
                                this.$refs.nsrsbh.focus();
                                return;
                            }
                        });
                }
            });
        },
        //提交
        async submit() {
            let result = await this.onSave(false);
            if (result) {
                this.$FG_http
                    .post("./api/jsaec/register/submit", {
                        id: this.editData.id
                        //,tjrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD HH:mm:ss")
                    })
                    .then(({ success, data, errMsg }) => {
                        this.tableDataLoading = false;
                        if (success) {
                            this.editDataId = this.editData.id;
                            // 返回列表
                            this.onBack();
                        } else {
                            this.$refs.yhm.focus();
                        }
                    });
            }
        },
        insertQtzzzsItem() {
            // 设置编辑记录
            let xh = this.$refs.QTZZZSitemTable.getInsertRecords().concat(this.$refs.QTZZZSitemTable.getUpdateRecords()).length + 1;
            this.$refs.QTZZZSitemTable.insertAt(
                {
                    isnew: true,
                    id: this.$FG_util.uuid(),
                    zcsqbid: this.editData.id,
                    zzyxq: 5,
                    xh: xh
                },
                -1
            ).then(({ row }) => {
                this.$refs.QTZZZSitemTable.setActiveRow(row);
            });
        },
        // 删除明细
        removeQtzzzsItem(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.QTZZZSitemTable.remove(row);
                    } else {
                        this.editItemDataQTZZZSLoading = true;
                        this.$FG_http
                            .post("./api/jsaec/register/deleteQtzzzsMx", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.editItemDataQTZZZSLoading = false;
                                if (success) {
                                    this.loadItemDataQTZZZS();
                                }
                            });
                    }
                }
            });
        },
        insertFzjgItem() {
            // 设置编辑记录
            let xh = this.$refs.FZJGitemTable.getInsertRecords().concat(this.$refs.FZJGitemTable.getUpdateRecords()).length + 1;
            this.$refs.FZJGitemTable.insertAt(
                {
                    isnew: true,
                    id: this.$FG_util.uuid(),
                    zcsqbid: this.editData.id,
                    xh: xh
                },
                -1
            ).then(({ row }) => {
                this.$refs.FZJGitemTable.setActiveRow(row);
            });
        },
        // 删除明细
        removeFzjgItem(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.FZJGitemTable.remove(row);
                    } else {
                        this.editItemDataFZJGLoading = true;
                        this.$FG_http
                            .post("./api/jsaec/register/deleteFzjgMx", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.editItemDataGZJGLoading = false;
                                if (success) {
                                    this.loadItemDataFZJG();
                                }
                            });
                    }
                }
            });
        },
        insertLxrItem() {
            // 设置编辑记录
            let xh = this.$refs.LXRitemTable.getInsertRecords().concat(this.$refs.LXRitemTable.getUpdateRecords()).length + 1;
            this.$FG_helper.handleNewBillCodeForRegister("TXYZSBH").then((val) => {
                this.$refs.LXRitemTable.insertAt(
                    {
                        isnew: true,
                        id: this.$FG_util.uuid(),
                        zcsqbid: this.editData.id,
                        zsbh: val,
                        xh: xh
                    },
                    -1
                ).then(({ row }) => {
                    this.$refs.LXRitemTable.setActiveRow(row);
                });
            });
        },
        // 删除明细
        removeLxrItem(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.LXRitemTable.remove(row);
                    } else {
                        this.editItemDataLXRLoading = true;
                        this.$FG_http
                            .post("./api/jsaec/register/deleteLxrMx", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.editItemDataLXRLoading = false;
                                if (success) {
                                    this.loadItemDataItem();
                                }
                            });
                    }
                }
            });
        },
        // 返回列表
        onBack() {
            this.$router.go(-1);
        },
        // 附件管理
        attachInsert(row) {
            // 设置编辑记录id
            this.attachProps.fkvalue = row.id;
            // 显示编辑窗口
            this.attachProps.visible = true;
        }
    },
    beforeRouteLeave(to, from, next) {
        this.setUserInfo(null);
        this.setToken(null);
        this.setStaticVarData({});
        this.setMessageData({});
        this.setSelectData({});
        this.setDictData({});
        this.setObjVarData({});
        next();
    }
};
</script>
<style lang="scss" scoped></style>
